export default "__VITE_ASSET__DxoelP_v__"